import request from '@/utils/request'

// 获取订单列表
export function getOrderList(data) {
  return request({
    method: 'post',
    path: 'store_order/lists',
    data
  })
}

// 获取订单详情
export function getOrderDetail(data) {
  return request({
    method: 'post',
    path: 'store_order/detail',
    data
  })
}

// 获取订单预览
export function getOrderPreview(data) {
  return request({
    method: 'post',
    path: 'store_order/preview',
    data
  })
}




// 订单确认完成
export function setFinish(data) {
  return request({
    method: 'post',
    path: 'store_order/setFinish',
    data
  })
}


// 设为已发货
export function setShip(data) {
  return request({
    method: 'post',
    path: 'store_order/setShip',
    data
  })
}



// 获取订单定金预览
export function getOrderFirstPay(data) {
  return request({
    method: 'post',
    path: 'store_order/getOrderFirstPay',
    data
  })
}


// 订单确认定金
export function setFirstPay(data) {
  return request({
    method: 'post',
    path: 'store_order/setFirstPay',
    data
  })
}




// 获取订单尾款预览
export function getOrderLastPay(data) {
  return request({
    method: 'post',
    path: 'store_order/getOrderLastPay',
    data
  })
}


// 订单确认尾款
export function setLastPay(data) {
  return request({
    method: 'post',
    path: 'store_order/setLastPay',
    data
  })
}

// 订单删除
export function setDelete(data) {
  return request({
    method: 'post',
    path: 'store_order/setDelete',
    data
  })
}


// 创建订单
export function addOrder(data) {
  return request({
    method: 'post',
    path: 'integral/addOrder',
    data
  })
}
